import { DialogComponent } from '@theme/dialog';
import { CartAddEvent } from '@theme/events';

/** The same live shopping bag opens from the header and after adding a product. */
class CartDrawerComponent extends DialogComponent {
  #request = 0;

  connectedCallback() {
    super.connectedCallback();
    document.addEventListener(CartAddEvent.eventName, this.#handleCartAdd);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    this.#request += 1;
    document.removeEventListener(CartAddEvent.eventName, this.#handleCartAdd);
  }

  #handleCartAdd = async (event) => {
    if (!(event instanceof CartAddEvent) || event.detail?.data?.didError || !this.hasAttribute('auto-open')) return;
    const request = ++this.#request;
    // Let quick-add and search finish closing before opening the bag.
    for (const dialog of document.querySelectorAll('dialog[open]')) {
      if (dialog === this.refs.dialog) continue;
      if (dialog.classList.contains('dialog-closing')) {
        await new Promise((resolve) => dialog.addEventListener('close', resolve, { once: true }));
        continue;
      }
      let owner = dialog.parentElement;
      while (owner && !(owner instanceof DialogComponent)) owner = owner.parentElement;
      if (owner instanceof DialogComponent) await owner.closeDialog();
    }
    if (request !== this.#request || !this.isConnected) return;
    this.open();
  };

  open() {
    this.showDialog();
    customElements.whenDefined('shopify-payment-terms').then(() => {
      const content = document.querySelector('shopify-payment-terms')?.shadowRoot;
      content?.querySelector('#shopify-installments-cta')?.addEventListener('click', this.closeDialog, { once: true });
    });
  }

  close() { this.closeDialog(); }
}

if (!customElements.get('cart-drawer-component')) {
  customElements.define('cart-drawer-component', CartDrawerComponent);
}
